'use client';

import React, { createContext, PropsWithChildren } from 'react';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { DisplayContentInfo } from '@wconcept/wconcept-common/models/renewal/display';

const WomenPageContext = createContext(undefined);

export function WomenPageProvider({ children }: PropsWithChildren) {
  return (
    <WomenPageContext.Provider value={undefined}>
      {children}
    </WomenPageContext.Provider>
  );
}

// Zustand store
type WoemnPageStore = {
  bannerList: DisplayContentInfo[];
  activeIndex: number;
  fullPopupIsClosed: boolean;
  coachMarkIsClosed: boolean;
  bottomPopupClosed: boolean;
  setBannerList: (payloade: DisplayContentInfo[]) => void;
  setActiveIndex: (idx: number) => void;
  setFullPopupIsClosed: (isClosed: boolean) => void;
  setCoachMarkIsClosed: (isClosed: boolean) => void;
  setBottomPopupClosed: (isClosed: boolean) => void;
  getBannerList: () => DisplayContentInfo[];
  getActiveIndex: () => number;
  getFullPopupIsClosed: () => boolean;
  getCoachMarkIsClosed: () => boolean;
  getBottomPopupClosed: () => boolean;
};

export const useWomenPageStore = create(
  persist<WoemnPageStore>(
    (set, get) => ({
      bannerList: [],
      activeIndex: 0,
      fullPopupIsClosed: false,
      coachMarkIsClosed: false,
      bottomPopupClosed: true,
      setBannerList: payloade => {
        set({
          bannerList: payloade,
        });
      },
      getBannerList: () => get().bannerList,
      setActiveIndex: idx => {
        set({
          activeIndex: idx,
        });
      },
      getActiveIndex: () => get().activeIndex,
      setFullPopupIsClosed: isClosed => {
        set({
          fullPopupIsClosed: isClosed,
        });
      },
      getFullPopupIsClosed: () => get().fullPopupIsClosed,
      setCoachMarkIsClosed: isClosed => {
        set({
          coachMarkIsClosed: isClosed,
        });
      },
      getCoachMarkIsClosed: () => get().coachMarkIsClosed,
      setBottomPopupClosed: isClosed => {
        set({
          bottomPopupClosed: isClosed,
        });
      },
      getBottomPopupClosed: () => get().bottomPopupClosed,
    }),
    {
      name: 'women-page-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

// Combined hook for convenience
export const useWomenPageController = () => {
  const womenPageStore = useWomenPageStore();

  return {
    ...womenPageStore,
  };
};
